export interface TabItem<T extends string = string> {
  key: T;
  label: string;
  count?: number;
}

interface TabProps<T extends string = string> {
  tabs: TabItem<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

export function Tab<T extends string = string>({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}: TabProps<T>) {
  return (
    <div className={`flex items-center gap-8 p-1 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-4 py-2 text-sm font-semibold rounded-sm transition-colors ${
            activeTab === tab.key
              ? 'bg-wine-100 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-200/20'
          }`}
        >
          {tab.label} {tab.count !== undefined && `(${tab.count})`}
        </button>
      ))}
    </div>
  );
}

export default Tab;
